<template>
  <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute left-0 top-0 pointer-events-none" />
  <div class="relative z-10">
    <div class="flex space-x-4 items-center text-2xl font-medium">
      <ClipboardPaste color="black" />
      <div>{{ $t("Send Survey") }}</div>
    </div>
    <!-- <div class="text-common-grey text-sm">
      Select Contacts to send survey to
    </div> -->
  </div>

  <ContactsSelect v-model:selected-contacts="selected_contacts" :multi-select="true" :label="$t('Select contacts')" />

  <div class="flex mt-6 w-full justify-between">
    <button class="text-dark-brand-blue" @click="$emit('cancel')">{{ $t("Cancel") }}</button>

    <button
      :class="{ 'opacity-60 pointer-events-none': !selected_contacts.length }"
      class="btn primary-btn w-fit !ml-auto"
      @click="sendSurvey">
      {{ $t("Send Survey") }}
    </button>
  </div>
</template>

<script>
import { ClipboardPaste } from "lucide-vue-next"
import ContactsSelect from "@/components/shared/ContactsSelect.vue"
import dataService from "@/services/data.service"

export default {
  components: { ClipboardPaste, ContactsSelect },
  props: { survey: null },
  emits: ["cancel", "done"],
  data() {
    return {
      selected_contacts: []
    }
  },
  watch: {},

  created() {},

  methods: {
    sendSurvey() {
      dataService.sendSurvey(this.survey.id, { records: this.selected_contacts.map((c) => c.id) }).then(() => {
        this.$emit("done")
      })
    }
  }
}
</script>
